<template>
     <a-drawer
      title="梯度分析"
      placement="right"
      :closable="true"
      :visible="hidden"
      :width="1100"
      :destroyOnClose="true"
      :forceRender="true"
      :bodyStyle="bodyStyle"
      :wrapStyle="wrapStyle"
      wrapClassName="drawer"
      @close="onClose"
    >
    <div class="drawer-box" style="width:100%;height:100%">
      <div style="margin:40px 80px;">
      <a-steps :current="current" size="small">
        <a-step :title="item" :key="index" v-for="(item,index) in steps"/>
      </a-steps>
      </div>
      <div ref="containers" class="containers" style="width:100%;height: calc(100vh - 240px);">
        <analyse-form ref="analyseForm" @next="postAnalyse" v-show="current == 0" />
        <analyse-base ref="analyseBase" :res="result" v-if="current == 1" />
        <analyse-result :result="result" v-if="current == 2" />
      </div>
    </div>
      <div class="footer">
        <a-row justify="space-between" align="middle" type="flex">
          <a-space>
            <a-button @click="onClose">关闭</a-button>
            <a-button v-if="current == 1" @click="exportData">导出</a-button>
          </a-space>
          <a-space>
            <a-button type="primary" @click="prevStep" v-if="current !== 0">上一步</a-button>
            <a-button type="primary" :loading="analyseLoading" @click="nextStep" v-if="current !== this.steps.length - 1">{{current === 0 ? '开始分析' : '下一步'}}</a-button>
          </a-space>
        </a-row>
      </div>
    </a-drawer>
</template>

<script>
import AnalyseForm from '../analyse/AnalyseForm.vue'
import AnalyseResult from '../analyse/AnalyseResult.vue'
import AnalyseBase from '../analyse/AnalyseBase.vue'
import { formulaMixins } from '../unitls'

import {getRequest} from '@/components/Common/Utils/Utils'

export default {
  components: { AnalyseResult, AnalyseForm, AnalyseBase },
  props:['hidden'],
  mixins:[formulaMixins],
  data(){
    return {
      steps:['填写基础信息','组成成分'],
      current: 0,
      result:{},
      analyseLoading:false,
      containerHeight:500,
      wrapStyle:{
        overflow:'hidden'
      },
      bodyStyle:{
        overflow:'hidden',
      },
      taskId: getRequest('id')
    }
  },
  watch:{
    hidden(){
      this.current = 0
    },
  },

  mounted(){
    this.current = 0
  },

  methods:{
    accMul(arg1,arg2) { 
      var m=0,s1=arg1.toString(),s2=arg2.toString(); 
      try{m+=s1.split(".")[1].length}catch(e){console.log(e)} 
      try{m+=s2.split(".")[1].length}catch(e){console.log(e)}
      return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m) 
    },
    async postAnalyse(data){
      data.taskId = this.taskId
      this.result = {}
      let res = await this.fetchPost({
        actions:this.ladderAnalysisFormulaTask,
        showMessage:false,
        loading:'analyseLoading',
        data
      })
      if(res && res.ladderList) {
        // this.result = (data.analysisSource == 2 && res.ladderList.length) ? {...res, ladderList:res.ladderList.map(i=> this.accMul(i,100))} : res
        this.result = res
        this.$nextTick(()=>{
          this.current++
        })
      }else {
        // this.$message.warn('配方无解')
        this.$warning({
          title: '优化失败',
          // content: <div><span style="color: red;">配方无解,</span>请检查配方中原料或者营养需要量</div>,
          content:res.msg,
          okText: '确定'
        })
      }
    },

    onClose(){
      this.$emit('close')
    },

    getResult(result){
      this.result = result
    },

    nextStep() {
      switch (this.current) {
        case 0:
          this.$refs['analyseForm'].postAnalyse()
          break;
        case 1:
          this.current++
        break
      }
    },
    
    prevStep() {
      this.current--
    },
    exportData(){
      if(this.$refs.analyseBase){
        let {analyseTable,analyseChart} = this.$refs.analyseBase.$refs
        if(analyseTable) analyseTable.downloadExcel()
        if(analyseChart) analyseChart.downloadChart()
      }
    }
  }
}
</script>


<style lang="scss" scoped>
  .footer{
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e9e9e9;
    padding: 10px 16px;
    background: #fff;
    text-align: right;
    z-index: 1;
  }

  .containers{
    width:100%;
    flex:1;
    height: calc( 100vh - 100px);
  }
  ::v-deep .drawer{
    overflow: hidden;
    .ant-drawer-wrapper-body,.ant-drawer-wrapper-body{
      overflow: hidden;
    }
  }
</style>
